export interface Project {
  id: string;
  name: string;
  nameVi?: string;
  description: string;
  descriptionVi?: string;
  category: 'backend' | 'cloud' | 'fullstack' | 'freelance';
  technologies: string[];
  memberId: string;
}

export const projects: Project[] = [
  {
    id: 'enterprise-goal-management',
    name: 'Enterprise Goal Management System',
    nameVi: 'Hệ thống Quản lý Mục tiêu Doanh nghiệp',
    description: 'Enterprise goal management system with multi-level organizational hierarchy and role-based access control. Built for Japanese market with fiscal year support and complex authorization.',
    descriptionVi: 'Hệ thống quản lý mục tiêu doanh nghiệp với phân cấp tổ chức đa tầng và kiểm soát truy cập theo vai trò. Xây dựng cho thị trường Nhật Bản với hỗ trợ năm tài chính và phân quyền phức tạp.',
    category: 'backend',
    technologies: ['Node.js', 'NestJS', 'TypeORM', 'PostgreSQL', 'AWS', 'Docker', 'GitHub Actions'],
    memberId: 'thanh-dm',
  },
  {
    id: 'ecommerce-management',
    name: 'E-commerce Management System',
    nameVi: 'Hệ thống Quản lý Thương mại Điện tử',
    description: 'Sales management system, online design and printing platform for banners and labels. Customers can customize designs and place orders.',
    descriptionVi: 'Hệ thống quản lý bán hàng, nền tảng thiết kế và in ấn trực tuyến cho banner và nhãn. Khách hàng có thể tùy chỉnh thiết kế và đặt hàng.',
    category: 'cloud',
    technologies: ['Go', 'AWS Lambda', 'SQS', 'PostgreSQL', 'Serverless'],
    memberId: 'thanh-dm',
  },
  {
    id: 'healthcare-support',
    name: 'Healthcare Support System',
    nameVi: 'Hệ thống Hỗ trợ Y tế',
    description: 'Healthcare platform for mother and baby wellness tracking, expert appointment scheduling, and health consultation services.',
    descriptionVi: 'Nền tảng chăm sóc sức khỏe theo dõi sức khỏe mẹ và bé, đặt lịch tư vấn chuyên gia, và dịch vụ tư vấn sức khỏe.',
    category: 'cloud',
    technologies: ['NestJS', 'Azure', 'PostgreSQL'],
    memberId: 'thanh-dm',
  },
  {
    id: 'freelance-projects',
    name: 'Freelance Projects',
    nameVi: 'Dự án Freelance',
    description: 'Various small-scale projects including feature modules and landing pages for startup businesses. Diverse technology stack and direct client collaboration.',
    descriptionVi: 'Các dự án quy mô nhỏ bao gồm module tính năng và landing page cho các startup. Đa dạng công nghệ và làm việc trực tiếp với khách hàng.',
    category: 'freelance',
    technologies: ['Django', 'Express', 'MongoDB', 'AWS', 'Stripe'],
    memberId: 'thanh-dm',
  },
  {
    id: 'seo-navigator-websites',
    name: 'SEO Navigator - Multi-industry Websites',
    nameVi: 'SEO Navigator - Website đa ngành',
    description: 'Designed and delivered full websites and landing pages for auto detailing businesses. Managed, updated, and optimized multiple client websites simultaneously using various CMS platforms.',
    descriptionVi: 'Thiết kế và triển khai website hoàn chỉnh và landing page cho các doanh nghiệp chăm sóc xe. Quản lý, cập nhật và tối ưu đồng thời nhiều website khách hàng trên nhiều nền tảng CMS.',
    category: 'fullstack',
    technologies: ['Duda', 'WordPress', 'Wix', 'Squarespace', 'GoHighLevel'],
    memberId: 'phat-tvp',
  },
  {
    id: 'global-liaison-wordpress',
    name: 'Global Liaison - Custom WordPress Sites',
    nameVi: 'Global Liaison - Website WordPress tùy chỉnh',
    description: 'Built custom websites using WordPress (DIVI) with unique visual effects, interactive features, and promotional elements. Developed responsive, SEO-friendly websites for nail spa and beauty businesses.',
    descriptionVi: 'Xây dựng website tùy chỉnh bằng WordPress (DIVI) với hiệu ứng hình ảnh, tính năng tương tác. Phát triển website responsive, thân thiện SEO cho các doanh nghiệp spa và làm đẹp.',
    category: 'fullstack',
    technologies: ['PHP', 'WordPress', 'DIVI', 'HTML/CSS', 'JavaScript', 'Figma'],
    memberId: 'phat-tvp',
  },
  {
    id: 'freelance-wordpress-projects',
    name: 'Freelance WordPress Projects',
    nameVi: 'Dự án WordPress Freelance',
    description: 'Designed, built, and maintained multiple client websites across various industries. Complete end-to-end solutions including hosting setup, deployment, domain configuration, security, and performance optimization.',
    descriptionVi: 'Thiết kế, xây dựng và bảo trì nhiều website khách hàng đa ngành. Giải pháp toàn diện từ đầu đến cuối bao gồm thiết lập hosting, triển khai, cấu hình tên miền, bảo mật và tối ưu hiệu năng.',
    category: 'freelance',
    technologies: ['WordPress', 'Flatsome', 'HTML/CSS', 'JavaScript', 'Bootstrap'],
    memberId: 'phat-tvp',
  },
  {
    id: 'device-management',
    name: 'Device Management System',
    nameVi: 'Hệ thống Quản lý Thiết bị',
    description: 'Backend API system for managing devices. Built with Node.js and containerized with Docker for scalable deployment.',
    descriptionVi: 'Hệ thống API Backend quản lý thiết bị. Xây dựng với Node.js và container hóa bằng Docker để triển khai mở rộng.',
    category: 'backend',
    technologies: ['Node.js', 'Docker', 'MySQL', 'TypeORM', 'Express'],
    memberId: 'nghia-lv',
  },
  {
    id: 'log-off-system',
    name: 'Log Off System',
    nameVi: 'Hệ thống Nghỉ phép',
    description: 'Employee leave management system providing functions related to logging day off, with approval processes and related functionality for all actors.',
    descriptionVi: 'Hệ thống quản lý nghỉ phép cho nhân viên, cung cấp chức năng đăng ký nghỉ phép, quy trình phê duyệt và các chức năng liên quan.',
    category: 'fullstack',
    technologies: ['React', 'Node.js', 'MongoDB', 'Docker'],
    memberId: 'nghia-lv',
  },
  {
    id: 'erp-system',
    name: 'ERP System',
    nameVi: 'Hệ thống ERP',
    description: 'Comprehensive ERP system providing tools to support all company activities. Serving more than 150 clients worldwide with modules for operations, HR, finance, and more.',
    descriptionVi: 'Hệ thống ERP toàn diện cung cấp công cụ hỗ trợ mọi hoạt động của công ty. Phục vụ hơn 150 khách hàng trên toàn thế giới với các module vận hành, nhân sự, tài chính và nhiều hơn nữa.',
    category: 'fullstack',
    technologies: ['HTML', 'CSS', 'JavaScript', 'Coldfusion', 'SQL'],
    memberId: 'nghia-lv',
  },
  {
    id: 'taas-airline-platform',
    name: 'TaaS — Major Airline Platform',
    nameVi: 'TaaS — Nền tảng Hàng không Lớn',
    description: 'Led a team of 5 developers to build and maintain a travel booking platform for a major airline, handling hotel reservations and rental car services at scale with high availability.',
    descriptionVi: 'Dẫn dắt nhóm 5 lập trình viên xây dựng và duy trì nền tảng đặt vé du lịch cho hãng hàng không lớn, xử lý đặt khách sạn và thuê xe quy mô lớn với tính khả dụng cao.',
    category: 'fullstack',
    technologies: ['Next.js', 'NestJS', 'Python', 'FastAPI', 'PostgreSQL', 'AWS ECS', 'Lambda', 'S3'],
    memberId: 'nguyen-lmt',
  },
  {
    id: 'ride-hailing-app',
    name: 'Ride-Hailing Mobile App',
    nameVi: 'Ứng dụng Đặt xe',
    description: 'A full-featured ride-hailing mobile application similar to Grab, supporting real-time driver matching, GPS tracking, route optimization, fare calculation, and in-app payments. Built with React Native for cross-platform deployment and integrated with Google Maps API for location services.',
    descriptionVi: 'Ứng dụng đặt xe di động đầy đủ tính năng tương tự Grab, hỗ trợ ghép tài xế real-time, theo dõi GPS, tối ưu lộ trình, tính cước và thanh toán trong ứng dụng. Xây dựng với React Native cho đa nền tảng và tích hợp Google Maps API cho dịch vụ định vị.',
    category: 'fullstack',
    technologies: ['React Native', 'Node.js', 'Google Maps API', 'Socket.IO', 'PostgreSQL', 'Redis'],
    memberId: 'nguyen-lmt',
  },
  {
    id: 'property-rental-management',
    name: 'Property Rental Management',
    nameVi: 'Quản lý Cho thuê Bất động sản',
    description: 'Developed and maintained a property rental management system serving the Australian real estate market, built with React frontend and Golang backend on PostgreSQL.',
    descriptionVi: 'Phát triển và duy trì hệ thống quản lý cho thuê bất động sản phục vụ thị trường Úc, xây dựng với React frontend và Golang backend trên PostgreSQL.',
    category: 'fullstack',
    technologies: ['React', 'Golang', 'Express.js', 'PostgreSQL', 'REST API'],
    memberId: 'nguyen-lmt',
  },
  {
    id: 'tournament-management',
    name: 'Tournament Management System',
    nameVi: 'Hệ thống Quản lý Giải đấu',
    description: 'Built a comprehensive tournament control system for martial arts competitions (Karate, Kendo, and more). Features include bracket generation, scoring, and real-time match tracking.',
    descriptionVi: 'Xây dựng hệ thống quản lý giải đấu cho các cuộc thi võ thuật (Karate, Kendo, v.v.). Bao gồm tạo nhánh thi đấu, chấm điểm và theo dõi trận đấu real-time.',
    category: 'fullstack',
    technologies: ['Vue.js', 'Golang', 'MySQL'],
    memberId: 'nguyen-lmt',
  },
  {
    id: 'invoice-ocr-processing',
    name: 'Invoice OCR Processing System',
    nameVi: 'Hệ thống Xử lý Hóa đơn OCR',
    description: 'Developed an intelligent invoice reading and processing system leveraging OCR technology to automate data extraction from scanned invoices, reducing manual entry time significantly.',
    descriptionVi: 'Phát triển hệ thống đọc và xử lý hóa đơn thông minh sử dụng OCR, tự động trích xuất dữ liệu từ hóa đơn scan, giảm đáng kể thời gian nhập liệu thủ công.',
    category: 'fullstack',
    technologies: ['Next.js', 'Django', 'MySQL', 'OCR'],
    memberId: 'nguyen-lmt',
  },
  {
    id: 'ev-charging-station',
    name: 'EV Charging Station IoT Platform',
    nameVi: 'Nền tảng IoT Trạm sạc Xe điện',
    description: 'Engineered an IoT-based electric vehicle charging station management system implementing OCPP protocol for real-time charger communication and monitoring.',
    descriptionVi: 'Xây dựng hệ thống quản lý trạm sạc xe điện IoT, triển khai giao thức OCPP để giao tiếp và giám sát real-time.',
    category: 'cloud',
    technologies: ['React', 'AWS (Chalice)', 'DynamoDB', 'OCPP', 'Serverless'],
    memberId: 'nguyen-lmt',
  },
];

export const projectCategories = [
  { id: 'all', label: 'All', labelVi: 'Tất cả' },
  { id: 'backend', label: 'Backend', labelVi: 'Backend' },
  { id: 'cloud', label: 'Cloud', labelVi: 'Cloud' },
  { id: 'fullstack', label: 'Full-stack', labelVi: 'Full-stack' },
  { id: 'freelance', label: 'Freelance', labelVi: 'Freelance' },
];
